// extracted by mini-css-extract-plugin
module.exports = {"spotlightWord":"SpotlightHeading_spotlightWord__otXSh","gradientWord":"SpotlightHeading_gradientWord__4hNwh","spotlight-drift":"SpotlightHeading_spotlight-drift__j3Iuu"};